import { Component, Vue, Watch } from 'vue-property-decorator'
import { createClassFeedback, deleteTableEdit, makeTimetableCreate, queryClassTimeTummary, queryTimeZoom, queryTummary, timeTableEdit, timeTableCourseType } from '@/api'
@Component({ name: 'start-course-page' })
export default class StartCoursePage extends Vue {
  private chooseCourseType: any = null
  private courseTypeList: any = [{ value: 1, label: '小组科研' }, { value: 2, label: '1v1' }, { value: 4, label: '论文小组' }]
  private timeZoomList: any = []
  private searchData: any = null
  private startAt: any = '' // 开始时间
  private endAt: any = '' // 结束时间
  private progressInput: any = ''
  private startCourseZoom: any = '' // 开课时区
  private fromDate: any = '' // 开课时间
  private continueWeek: any = '' // 持续的周数
  private whichWeek: any = ''
  private abnormalDetailList: any = '' // 异常详情
  private timeContinue: any = '' // 开课时长
  private activeItem: any ={}
  private teacherList: any = []
  private timetableList: any = []
  private currentPage: any = 1;
  private timecurrentPage: any = 1;
  private timeAllPage: any = 1
  private classList: any = []
  private classAllPage: any = 1
  private classOpeningItem: any = {};
  private time: any = null
  private time1: any = null
  private timeContinueList: any = [
    { value: 30, label: '30分钟' },
    { value: 45, label: '45分钟' },
    { value: 60, label: '60分钟' },
    { value: 75, label: '75分钟' },
    { value: 90, label: '90分钟' },
    { value: 105, label: '105分钟' },
    { value: 120, label: '120分钟' },
    { value: 150, label: '150分钟' },
    { value: 180, label: '180分钟' },
    { value: 210, label: '210分钟' }
  ]

  private pickerOptions: any = { // 限制开课时间不让选择今天以前的
    disabledDate (time: any) {
      return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
    }
  }

  private timetableEditObj: any = {}
  private loading: any = false
  // *****弹窗 开关*****
  private deleteCourseDialogShow = false // 删除课程的dialog
  private conflictDialogShow = false // 有冲突的dialog
  private projectProgressDialogShow = false // 项目进度弹窗
  private conflictDetailShow = false // 冲突具体弹窗
  private startProjectDialogShow = false // 开课的弹窗
  private updateProjectDialogShow = false // 调课的弹窗

  created () {
    this.queryTimeZoom()
  }

  @Watch('fromDate')
  changeFromDate (data: any) {
    this.whichWeek = new Date(data).getDay()
  }

  // 查询时区
  private async queryTimeZoom () {
    const result: any = await queryTimeZoom({})
    this.timeZoomList = result.zoneList
    this.courseTypeList = await timeTableCourseType({})
  }

  private async onCourseTypeChange () {
    this.classList = []
    this.teacherList = []
    this.currentPage = 1
    this.classAllPage = 1
    this.loadclassList()
  }

  private async onSearch () {
    this.onCourseTypeChange()
  }

  // 删除课程
  private async onDeleteCourseClick () {
    const result: any = await deleteTableEdit({ id: this.timetableEditObj.id })
    this.deleteCourseDialogShow = false
    this.$message({ message: '删除课程成功', type: 'success' })
    this.getEditÇlass()
  }

  // 主导师开课按钮点击
  classOpening (item: any, item1: any) {
    console.log('item1.teacherId: ', item1.teacherId)
    if (!item1.teacherId) {
      console.log('item1: ', item1)
      this.$message({ message: '对不起，该班级没有安排对应的老师，请先安排导师', type: 'warning' })
      return
    }
    const obj: any = {
      classId: item.classId,
      className: item.className,
      teacherRoleStr: item1.teacherRoleStr,
      teacherId: item1.teacherId
    }
    this.classOpeningItem = obj
    this.startProjectDialogShow = true
  }

  onCheckConflictClick () {
    this.conflictDialogShow = false
    this.conflictDetailShow = true
  }

  // 项目进度反馈填写
  private async onProjectProgressClick () {
    const obj: any = {
      classId: this.activeItem.classId,
      teacherId: '',
      id: this.timetableEditObj.id,
      detail: this.progressInput
    }
    const resultDetail: any = await createClassFeedback(obj)
    this.projectProgressDialogShow = false
    this.progressInput = ''
    this.clickitem(this.activeItem)
  }

  // 每个班级点击查看项目详情事件
  clickitem (item: any) {
    this.teacherList = []
    this.timetableList = []
    this.timeAllPage = ''
    this.activeItem = item
    this.timecurrentPage = 1
    item.teacherList.forEach((item: any) => {
      if (item) {
        this.teacherList.push(item.teacherId)
      }
    })
    this.loadtimetable()
  }

  // 开课接口
  private async onStartCourseClick () {
    if (!this.fromDate) {
      this.$message({ message: '日期不能为空', type: 'warning' })
      return
    }

    let date: any = new Date(this.fromDate)
    date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + this.startAt
    // const date = new Date((new Date(this.fromDate)).toDateString() + ' ' + this.startAt).getTime()
    const obj: any = {
      classId: this.classOpeningItem.classId,
      teacherId: this.classOpeningItem.teacherId,
      startAt: date,
      weekLoop: Number(this.continueWeek),
      week: Number(this.whichWeek),
      classTime: this.timeContinue,
      zone: this.startCourseZoom
    }
    const resultDetail: any = await makeTimetableCreate(obj)
    if (resultDetail.status === 1) {
      this.startProjectDialogShow = false
      this.$message({ message: '开课成功', type: 'success' })
      this.reset()
    } else {
      // 异常冲突详情
      if (!resultDetail.error) {
        this.startProjectDialogShow = false
        this.abnormalDetailList = resultDetail.detail
        this.onCheckConflictClick()
      }
    }
    this.getEditÇlass()
  }

  // 调整课表接口
  private async onUpdateCourseTimeClick () {
    if (!this.fromDate) {
      this.$message({ message: '日期不能为空', type: 'warning' })
      return
    }
    if (this.endAt <= this.startAt) {
      this.$message({ message: '结束日期大于开始日期', type: 'warning' })
      return
    }
    const d1: any = new Date(this.timetableEditObj.startTime)
    const d2: any = new Date(this.timetableEditObj.endTime)
    const gap = Math.abs(d2 - d1) / 1000 / 60 / 60
    const d3: any = new Date((new Date()).toDateString() + ' ' + this.startAt).getTime()
    const d4: any = new Date((new Date()).toDateString() + ' ' + this.endAt).getTime()
    const gap1 = Math.abs(d3 - d4) / 1000 / 60 / 60
    if (gap !== gap1) {
      this.$message({ message: '调整前的小时数要与调整后的小时数一致', type: 'warning' })
      return
    }
    let date: any = new Date(this.fromDate)
    date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + this.startAt
    let enddate: any = new Date(this.fromDate)
    enddate = enddate.getFullYear() + '-' + (enddate.getMonth() + 1) + '-' + enddate.getDate() + ' ' + this.endAt
    const obj = {
      startAt: date,
      timetableId: String(this.timetableEditObj.id),
      endAt: enddate
    }
    await timeTableEdit(obj)
    this.updateProjectDialogShow = false
    this.reset()
    this.getEditÇlass()
  }

  // 重置dialog v-model值；
  private reset () {
    this.fromDate = ''
    this.startAt = ''
    this.endAt = ''
    this.startCourseZoom = ''
    this.continueWeek = ''
    this.timeContinue = ''
  }

  // 删除和调课时 刷新左侧选中班级班级课时
  private async getEditÇlass () {
    this.clickitem(this.activeItem)
    const tummaryTesult: any = await queryTummary({ classId: this.activeItem.classId })
    this.$nextTick(() => {
      this.activeItem.finishNum = tummaryTesult.classList[0].finishNum
      this.activeItem.timetableNum = tummaryTesult.classList[0].timetableNum
    })
  }

  // 班级列表加载更多
  private async loadclassList () {
    if (this.classAllPage !== '' && (this.classAllPage < this.currentPage)) return
    this.timetableList = []
    this.loading = true
    const tummaryTesult: any = await queryTummary({ page: this.currentPage, limit: 20, className: this.searchData, courseType: this.chooseCourseType ? this.chooseCourseType : null })
    this.classAllPage = tummaryTesult.allPage
    if (this.currentPage === 1) {
      this.classList = tummaryTesult.classList || []
      if (this.classList.length > 0) {
        this.clickitem(this.classList[0])
      }
    } else {
      this.classList = [...this.classList, ...tummaryTesult.classList]
    }
    this.currentPage += 1
    this.loading = false
  }

  // 课程列表加载更多
  private async loadtimetable () {
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      if ((this.timeAllPage !== '' && (this.timeAllPage < this.timecurrentPage)) || !this.activeItem.classId) return
      const projectTesult: any = await queryClassTimeTummary({ teacherId: this.teacherList, classId: this.activeItem.classId, page: this.timecurrentPage, limit: 20 })
      if (this.timecurrentPage === 1) {
        this.timetableList = projectTesult.timetableList
      } else {
        this.timetableList = [...this.timetableList, ...projectTesult.timetableList]
      }
      this.timeAllPage = projectTesult.allPage
      this.timecurrentPage += 1
    }, 500)
  }

  // 删除课程
  onDeleteProjectClick (item: any) {
    this.timetableEditObj = item
    this.deleteCourseDialogShow = true
  }

  // 调整课表时间
  onUpdateProjectClick (item: any) {
    this.timetableEditObj = item
    this.updateProjectDialogShow = true
  }

  // 项目进度反馈点击事件
  onProjectTimeInputClick (item: any) {
    this.timetableEditObj = item
    this.projectProgressDialogShow = true
  }
}
